import Cookies from 'js-cookie';

export function getCookie(key) {
  return Cookies.get(key);
}

export function setCookie(key, value) {
  if (key !== undefined) {
    return Cookies.set(key, value, { path: '/' });
  }
}

export function removeCookie(key) {
  Cookies.remove(key, { path: '/' });
}

export function clearCookie() {
  const cookie = Cookies.get();
  Object.keys(cookie).forEach(key => {
    Cookies.remove(key);
  });
  return cookie;
}
